import { render } from "./ErrorAlerts.vue?vue&type=template&id=38d54be7&scoped=true&lang=html"
import script from "./ErrorAlerts.vue?vue&type=script&setup=true&lang=js"
export * from "./ErrorAlerts.vue?vue&type=script&setup=true&lang=js"

import "./ErrorAlerts.vue?vue&type=style&index=0&id=38d54be7&lang=css&scoped=true"

import exportComponent from "/home/interact/webapp/4.frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38d54be7"]])

export default __exports__